import React from 'react';
import ContactForm from '../ContactFrom/ContactForm';

const Contactpage = () => {
  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container-fluid">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              <div className="row">
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-placeholder"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Address</h2>
                      <p>
                        Golden Cleaning Company WLL P.O Box 30007, Doha, Qatar
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-email"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Email Us</h2>
                      <p>info@goldencleaningcompany.net</p>
                      <p>gccwllqatar@gmail.com</p>
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <i className="fi flaticon-phone-call"></i>
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Call Now</h2>
                      <p>+974 44411170</p>
                      <p>+974 66117681</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpo-contact-title">
              <h2>Have Any Question?</h2>
            </div>
            <div className="wpo-contact-form-area">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <section className="wpo-contact-map-section">
        <div className="wpo-contact-map">
          <iframe
            title="Golden Cleaning Company location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.937837461993!2d51.5154093104904!3d25.272676477569274!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e45c56b363f5c7b%3A0xe0e6678e4decd47f!2sGolden%20Cleaning%20Company.W.L.L!5e0!3m2!1sen!2sin!4v1686028093698!5m2!1sen!2sin"
          />
        </div>
      </section>
    </section>
  );
};

export default Contactpage;
